import {handleBoostEvent} from './boost';
import {handleGeneralEvent} from './GeneralEventHandler';
import {handleMatchesEvent} from './MatchesEventHandler';
import {handleUserDataEvent} from './UserDataEventHandler';

export const eventHandlers = [
  handleMatchesEvent,
  handleUserDataEvent,
  handleGeneralEvent,
  handleBoostEvent,
];
